import {Menu, X} from 'lucide-react'
import { useEffect, useState } from 'react'

const LOGO_IMAGE = 'https://static.lumi.new/90/90780d3e0e5e5c46f70ed4649948fe40.webp'

const navLinks = [
  { label: '首頁', href: '#hero' },
  { label: '香氛特色', href: '#highlights' },
  { label: '常見問題', href: '#faq' },
  { label: '立即預購', href: '#order' },
]

function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const onScroll = () => {
      try {
        setScrolled((window.scrollY || 0) > 24)
      } catch {
        setScrolled(false)
      }
    }
    window.addEventListener('scroll', onScroll)
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-zinc-950/90 backdrop-blur-md border-b border-zinc-800' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-between h-14 lg:h-20">
        <a href="#hero" className="flex items-center" style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: 0, margin: 0 }}>
          <img
            src={LOGO_IMAGE}
            alt="MR.EAR 耳朵先生 The Taste Of... 限定收藏香氛"
            style={{ height: '36px', width: 'auto', background: 'transparent', border: 'none', boxShadow: 'none', padding: 0, margin: 0, filter: 'none' }}
            className="block"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.slice(0, -1).map(link => (
            <a key={link.href} href={link.href} className="text-sm text-stone-300 hover:text-stone-50 transition-colors tracking-wide">
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#order"
          className="hidden lg:inline-flex items-center justify-center px-5 py-2.5 min-h-12 text-sm tracking-wide text-zinc-950 bg-rose-300 hover:bg-rose-200 active:scale-95 transition-all rounded-sm"
        >
          立即預購
        </a>

        <button
          type="button"
          onClick={() => setMenuOpen(prev => !prev)}
          className="lg:hidden text-stone-50 min-h-11 min-w-11 flex items-center justify-center"
          aria-label="開啟選單"
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {menuOpen
        ? (
            <div className="lg:hidden bg-zinc-950 border-t border-zinc-800 px-6 py-6 flex flex-col gap-2">
              {navLinks.map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="text-stone-200 text-base tracking-wide min-h-12 flex items-center"
                >
                  {link.label}
                </a>
              ))}
            </div>
          )
        : null}
    </header>
  )
}

export default Navbar
